export const baseConf = {
  ninetailed: {
    clientId: '2d96898c-e3ab-40b7-a6f4-50f80e95206a',
  },
  qualified: {
    token: 'SWP2vgTKwt4Sucin',
    url: 'https://js.qualified.com/qualified.js',
  },
  acquisitionTracking: {
    googleAnalytics: {
      id: 'UA-6331378-16',
    },
    googleTagManager: {
      id: 'GTM-KPPHBZ',
      layer: 'Test',
    },
  },
  paths: {
    funnel: {
      llamaDownloadFirst: '/service/download?downloadFirst=true',
      llamaDownloadDirect: '/service/download/direct',
      signup: '/signup',
      signin: '/signin',
      businessSignin: '/business/signin',
      eduSignin: '/enterprise/signin',
      upgrade: '/upgrade',
    },
    blog: {
      main: '/blog/',
      affiliate: '/blog/category/affiliate-marketing/',
      featureNews: '/blog/category/product',
      engineering: '/blog/engineering/',
      business: '/business/learn',
      handbook: '/blog/category/handbook',
      education: '/blog/category/education/',
    },
  },
  products: {
    keyboard: {
      ios: 'https://itunes.apple.com/app/id1158877342',
      ipad: 'https://itunes.apple.com/app/id1158877342#?platform=ipad',
      android: 'https://play.google.com/store/apps/details?id=com.grammarly.android.keyboard',
    },
    extension: {
      chrome: {
        browserFriendlyName: 'Chrome',
        webLandingPageUrlPath: '/chrome',
        downloadUrl:
          'https://chromewebstore.google.com/detail/grammarly-grammar-checker/kbfnbcaeplbcioakkpcpgfkobkghlhen',
      },
      firefox: {
        browserFriendlyName: 'Firefox',
        webLandingPageUrlPath: '/firefox',
        downloadUrl: 'https://addons.mozilla.org/firefox/downloads/latest/566314/addon-566314-latest.xpi',
        iconUrl: 'https://addons.cdn.mozilla.net/user-media/addon_icons/566/566314-32.png',
        galleryUrl: 'https://addons.mozilla.org/en-US/firefox/addon/grammarly-1/',
      },
      safari: {
        browserFriendlyName: 'Safari',
        webLandingPageUrlPath: '/safari',
        downloadUrl: 'https://apps.apple.com/us/app/grammarly-for-safari/id1462114288?ls=1&mt=12',
        galleryUrl: 'https://safari-extensions.apple.com/details/?id=com.grammarly.spellchecker.extension-W8F64X92K3',
        support: 'https://support.grammarly.com/hc/en-us/articles/360028736111',
      },
      edge: {
        browserFriendlyName: 'Microsoft Edge',
        webLandingPageUrlPath: '/edge',
        downloadUrl: 'ms-windows-store://pdp?ProductId=9p59wxtbhzzm',
        galleryUrl: 'https://www.microsoft.com/en-us/store/p/grammarly-for-microsoft-edge/9p59wxtbhzzm?rtc=1',
      },
      edgeChromium: {
        browserFriendlyName: 'Microsoft Edge',
        webLandingPageUrlPath: '/edge',
        downloadUrl: 'https://microsoftedge.microsoft.com/addons/detail/cnlefmmeadmemmdciolhbnfeacpdfbkd',
      },
    },
    llama: {
      windowsDownloadUrl: 'https://download-windows.grammarly.com/GrammarlyInstaller.exe',
      macDownloadUrl: 'https://download-mac.grammarly.com/Grammarly.dmg',
    },
    editor: {
      macDownloadUrl: 'https://download-editor.grammarly.com/osx/Grammarly.dmg',
      windowsDownloadUrl: 'https://download-editor.grammarly.com/windows/GrammarlySetup.exe',
    },
  },
  social: {
    facebookShareUrlDeprecated: 'https://www.facebook.com/sharer/sharer.php',
    facebookShareUrl: 'https://www.facebook.com/dialog/share',
    facebookMessengerShareUrl: 'https://www.facebook.com/dialog/send',
    linkedInShareUrl: 'https://www.linkedin.com/sharing/share-offsite/',
    xShareUrl: 'https://twitter.com/intent/tweet',
    facebookAppId: '',
    facebookMessengerAppId: '203198053709806',
  },
} as const
